// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ace21015","623":"74c085ad","850":"b4cb4c59","944":"d4a476fd"}[chunkId] + ".chunk.js";
};